/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Geliver_Sendungen_Msg_ErrorInputs */

const tr_geliver_sendungen_msg_error = /** @type {(inputs: Geliver_Sendungen_Msg_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hata: ${i?.message}`)
};

const en_geliver_sendungen_msg_error = /** @type {(inputs: Geliver_Sendungen_Msg_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const de_geliver_sendungen_msg_error = /** @type {(inputs: Geliver_Sendungen_Msg_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler: ${i?.message}`)
};

const ru_geliver_sendungen_msg_error = /** @type {(inputs: Geliver_Sendungen_Msg_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Error: {message}" |
*
* @param {Geliver_Sendungen_Msg_ErrorInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_sendungen_msg_error = /** @type {((inputs: Geliver_Sendungen_Msg_ErrorInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Sendungen_Msg_ErrorInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_sendungen_msg_error(inputs)
	if (locale === "de") return de_geliver_sendungen_msg_error(inputs)
	if (locale === "ru") return ru_geliver_sendungen_msg_error(inputs)
	return tr_geliver_sendungen_msg_error(inputs)
});